import React from 'react';

interface LogoProps {
  className?: string;
  src?: string;
  alt?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '', src = '/logo.png', alt = '1701 Logo' }) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="relative">
        <img
          src={src}
          alt={alt}
          className="max-w-[120px] max-h-[80px] w-auto h-auto object-contain"
        />
      </div>
    </div>
  );
};

export default Logo;

